<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 物流管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>WMS出库异常日志</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="运单号" prop="freight_bill_code">
                <el-input v-model="searchform.freight_bill_code" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
             <el-col :span="6">
              <el-form-item label="出库单号" prop="outbill_code">
                <el-input v-model="searchform.outbill_code" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="二维码" prop="qrcode">
                <el-input v-model="searchform.qrcode" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出库类型" prop="log_type">
                 <el-select v-model="searchform.log_type" style="width:100%" placeholder="请选择退货类型">
                  <el-option
                    v-for="item in log_type"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="datelist" >
                   <el-date-picker
                           style="width:100%"
                           v-model="searchform.datelist"
                           type="daterange"
                            value-format="yyyy-MM-dd"
                           range-separator="-"
                           start-placeholder="开始日期"
                           end-placeholder="结束日期">
                   </el-date-picker>
              </el-form-item>
            </el-col>     
          </el-row>
                      <el-row>
            <el-col :span="8" :offset="1"> 
               <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['loglist_select']">搜索</el-button>
               <el-button
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
                v-permission="['loglist_export']"
              >导出Excel</el-button>
            </el-col>
            </el-row> 
        </el-form>
      </div>
<br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>WMS出库异常日志</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="freight_bill_code" label="运单号" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outbill_code" label="出库单号" min-width="120" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="log_guid" label="日志编号" min-width="100" show-overflow-tooltip></el-table-column> -->
            <el-table-column prop="log_type" label="日志类型" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="创建时间" min-width="140" show-overflow-tooltip fixed="right"></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,40,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { logindex } from "@/api/plant";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //导出表格变量
      tableDataDownload:[],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
     log_type:[
       {
         value:0,
         label:"退货"
       },
       {
         value:1,
         label:"换货"
       },
       {
         value:2,
         label:"正常出库"
       },
       {
         value:3,
         label:"退换货"
       }
     ],
      searchform: {
        qrcode:null,
        freight_bill_code:null,
        datelist:[],
        outbill_code:null,
        log_type: null,
        currPage:1,
        pageSize:10
      }
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      logindex(obj).then(response => {
        this.tableData = response.data.data;
        this.packdate(this.tableData);
        this.total_count = response.data.total_count;
        this.currentPage = response.data.page_index;
        this.listLoading = false;
        console.log(this.tableData)
      });
    },
    // 拼装数据
    packdate(obj){
       for (let i = 0; i < obj.length; i++) {
         obj[i].create_time = obj[i].create_time.replace(/T/, " ");
         switch (obj[i].log_type) {
            case 0:obj[i].log_type = "退货"           
            break;
            case 1:obj[i].log_type = "换货"           
            break;
            case 2:obj[i].log_type = "正常出库"           
            break;
            case 3:obj[i].log_type = "退换货"           
            break;
          default:
            break;
        };
        }
    },
    //搜索事件
    search() {
        this.Tabledata({
          qrcode:this.searchform.qrcode,
        freight_bill_code:this.searchform.freight_bill_code,
        outbill_code:this.searchform.outbill_code,
        log_type:this.searchform.log_type,
        create_start_time: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        create_end_time:this.searchform.datelist==null ? null:this.searchform.datelist[1],
        pageSize:this.searchform.pageSize,
        pageIndex:1,
        });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage
       this.Tabledata({
          qrcode:this.searchform.qrcode,
        freight_bill_code:this.searchform.freight_bill_code,
        outbill_code:this.searchform.outbill_code,
        log_type:this.searchform.log_type,
        create_start_time: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        create_end_time:this.searchform.datelist==null ? null:this.searchform.datelist[1],
        pageSize:this.searchform.pageSize,
        pageIndex:this.searchform.currPage,
        });
      console.log(currPage)
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize
      this.search()
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        pageIndex:1,
        pageSize:this.total_count,
        freight_bill_code:this.searchform.freight_bill_code,
        outbill_code:this.searchform.outbill_code,
        log_type:this.searchform.log_type,
        create_start_time: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        create_end_time:this.searchform.datelist==null ? null:this.searchform.datelist[1],
      };
     logindex(obj).then(response => {
        this.tableDataDownload = response.data.data;
        this.packdate(this.tableDataDownload);
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = ["运单号", "出库单号",  "日志类型", "备注","创建时间"];
        const filterVal =["freight_bill_code", "outbill_code",  "log_type", "remark","create_time"];
        const list = this.tableDataDownload;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        });
        this.downloadLoading = false;
      });
            }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>

</style>